import BugReportIcon from '@mui/icons-material/BugReport';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import { DebugPanel } from '@/components/DebugPanel';
import globals from '@/lib/globals';
import { authSelectors } from '@/state/auth';

interface Props {
    onTanstackToggle?: () => void;
    tanstackOpen?: boolean;
}

export const DebugControls = ({ onTanstackToggle, tanstackOpen = false }: Props) => {
    const isSuperuser = useSelector(authSelectors.isSuperuser);
    const [debugOpen, setDebugOpen] = useState(false);

    if (!isSuperuser && globals.environment !== 'local') return null;

    return (
        <>
            <Tooltip title="TanStack Query Devtools">
                <IconButton
                    size="small"
                    onClick={onTanstackToggle}
                    sx={{ color: tanstackOpen ? 'primary.light' : '#fff' }}
                >
                    <QueryStatsIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <Tooltip title="Debug Panel">
                <IconButton
                    size="small"
                    onClick={() => setDebugOpen((o) => !o)}
                    sx={{ color: debugOpen ? 'primary.light' : '#fff' }}
                >
                    <BugReportIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <DebugPanel open={debugOpen} onClose={() => setDebugOpen(false)} />
        </>
    );
};
